// Reads window.DD_RUM directly (set by portal's RUM init or Rails' CDN snippet).
// Don't import portal/app/lib/datadog.ts here -- double inits RUM in Rails bundle.
interface RumGlobal {
  addAction(name: string, context?: object): void
  getInitConfiguration(): unknown
}

const getRum = (): RumGlobal | null => {
  if (typeof window === 'undefined') return null

  const rum = (window as unknown as { DD_RUM?: unknown }).DD_RUM
  if (
    rum &&
    typeof (rum as RumGlobal).addAction === 'function' &&
    typeof (rum as RumGlobal).getInitConfiguration === 'function'
  ) {
    return rum as RumGlobal
  }

  return null
}

/** RUM custom action. No-op if RUM absent/uninitialized. Never throws. */
export const trackRumAction = (name: string, context?: object) => {
  const rum = getRum()
  if (!rum || !rum.getInitConfiguration()) return

  try {
    rum.addAction(name, context)
  } catch {}
}
